import React, { Component } from "react";
import styles from "./Item.local.scss";
import classnames from "classnames";

class OrganizationFilterFetching extends Component {
  render() {
    let status = [];
    for (let i = 0; i < 4; i++) {
      status.push(
        <div
          key={i}
          className={classnames(
            styles.presentation_filter_button_fetching,
            styles.gradiant
          )}
        />
      );
    }

    return <div className={styles.actions}>{status}</div>;
  }
}

export default OrganizationFilterFetching;



// WEBPACK FOOTER //
// ./src/components/OrganizationList/OrganizationFilterFetching.js